// extracted by mini-css-extract-plugin
module.exports = {"root":"AdditionalProductsSection_root__1PA9S","newTag":"AdditionalProductsSection_newTag___fQg3","title":"AdditionalProductsSection_title__NBxz0"};